import React from 'react'
import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'

const BOECancellationPolicyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '0.5rem',
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
  [theme.breakpoints.down('sm')]: {
    margin: '0 1rem',
  },
}))

function BOECancellationPolicy() {
  return (
    <BOECancellationPolicyContainer>
      <Typography sx={{fontSize: '24px', fontWeight: 'bold'}} color="white">
        Cancellation Policy
      </Typography>
      <Typography
        variant="caption"
        color="white"
        textTransform="initial"
        marginBottom="0.5rem"
      >
        Border Overflight Exemption (BOE) requests are non-refundable and once
        this BOE request has been submitted, the following applies:
      </Typography>
      <ul>
        <li>Operator name cannot be changed</li>
        <li>Submission date cannot be changed</li>
        <li>Processing fee cannot be refunded</li>
        <li>Processing fee cannot be changed or discounted</li>
        <li>CST Members who fail to validate their CST Member email during this submission process will be charged full rate and no partial refunds can be given</li>
      </ul>
    </BOECancellationPolicyContainer>
  )
}

export default BOECancellationPolicy
